import axios from 'axios'
import store from '@/store/index';
import router from '../router/index'
import {Message} from 'element-ui';

let base_url = '/apis';
let base_url_video = '/apisVideo';
//创建axios实例
var service = axios.create({
  baseURL: base_url,
  withCredentials: true,
  timeout: 50000000
})

// var serviceVideo = axios.create({
//   baseURL: base_url_video,
//   timeout: 50000000
// })

export default {
  service,
  //get请求
  get(url, data, $method, timeout) {
    let date = timeout || 5 * 60 * 1000
    return service({
      url: url,
      method: 'get',
      params: data,
      timeout: date,
      headers: {
        'content-type': 'application/json',
        'ref': store.state.ref
      }
    }).then(res => {
      // $method(res.data);
      // if(!store.state.ref){
      // 	console.log('登录过期')
      // 	router.push("/");
      // }
      // console.log(res.data)
      if (res.data.code && res.data.code == '44001') {
        // router.push("/");
        this.handleSignOut()
      } else {

        $method(res.data);
      }
    }).catch(err => {
      this.handleSignOut()
    })
  },
  post(url, data, $method, timeout) {
    let date = timeout || 5 * 60 * 1000
    return service({
      url: url,
      method: 'post',
      params: data,
      timeout: date,
      // data,
      headers: {
        'content-type': 'application/json',
        'ref': store.state.ref
      }
    }).then(res => {
      if (res.data.code && res.data.code === '44001') {
        this.handleSignOut()
      } else {
        $method(res.data);
      }
    }).catch(err => {
      this.handleSignOut()
    })
  },
  postJsonData(url, data, callback) {
    return service.post(url, data, {
      headers: {
        'ref': store.state.ref,
        'Content-Type': 'application/json'
      }
    }).then(res => {
      if (res.data.code === '44001') {
        this.handleSignOut();
      } else {
        callback(res.data);
      }
    }).catch(err => {
      this.handleSignOut();
    });
  },
  postData(url, data, $method) {
    const formData = new FormData();
    for (const key in data) {
      if (data[key]!== null) {
        formData.append(key, data[key])
      }
    }
    return service.post(url, formData, {
      headers: {
        'ref': store.state.ref
      }
    }).then(res => {
      if (res.data.code && res.data.code === '44001') {
        this.handleSignOut()
      } else {
        $method(res.data);
      }
    }).catch(err => {
      this.handleSignOut()
    })
  },
  // 退出
  handleSignOut() {
    // Message.error('登录过期,重新登录！！')
    // store.commit("clearLoginInfo");
    // console.log(router.currentRoute.path)
    // if (router.currentRoute.path !== '/login') {
    //   router.push("/");
    // }
    // console.log(store)
    // let success = function (resp) {
    //   console.log('退出')
    //
    // };
    // if (store.state.userId) {
    //   this.get(
    //     // "/sys/online/forceLogout1/userid?" + _this.$store.state.userId,
    //     "/wxf/forceLogout1/" + store.state.userId,
    //     {},
    //     success
    //   );
    // }
  },
  postFormData(url, data, $method) {
    return service({
      url: url,
      method: 'post',
      params: data,
      headers: {
        'ref': store.state.ref
      }
    }).then(res => {
      $method(res.data);
    }).catch(err => {
      router.push("/");
    })
  },
  postFile(url, data, $method) {
    return service({
      headers: {
        'Content-Type': 'multipart/form-data;',
        'ref': store.state.ref
      },
      url: url,
      method: 'post',
      data: data
    }).then(res => {
      $method(res.data);
    })
  },
  getDownloadFile(url, string) {
    return service({
      headers: {
        'Content-Type': 'application/x-www-form-urlencode',
        'ref': store.state.ref
      },
      url: url,
      method: 'get',
      timeout: 6000000,
      responseType: 'blob'
    }).then(response => {
      if (response.status == "200") {
        var blob = new Blob([response.data])
        var downloadElement = document.createElement('a');
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = string + '.xls'; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      } else {
        Message({
          type: "error",
          message: res.data.message,
          duration: "1000"
        })
      }
    }).catch(err => {
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/http.js